import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBiDirectionalArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_6118_14515)",
		children: /* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_6118_14515)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M2.5 10.0001H17.5M2.5 10.0001L5.83333 6.66675M2.5 10.0001L5.83333 13.3334M17.5 10.0001L14.1667 13.3334M17.5 10.0001L14.1667 6.66675",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6118_14515",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_6118_14515",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
			fill: "white"
		})
	})] })]
});
export default SvgBiDirectionalArrow;
